import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import CustomFetch from "@/Utils/APIRequest/AxiosInstance";
import { AdminUserSocialMediaPostsListAPI } from "@/Utils/APIRequest/Endpoints";
import ImageWithFallback from "../../ImageWithFallback";
import SkeletonLoader from "@/Layout/SkeletonLoader";
import moment from "moment";
import { CommentsSVG, FacebookLikeSVG, InstagramLikesSVG } from "../../SVGs/CommonSVG";
import { formatNumber } from "@/Utils/Other/FormateNumbers";
import { RiEye2Line, RiEyeLine } from "react-icons/ri";

const DetailInstagramPosts = (props) => {
    const { postId, translations, skeletonLoading, stopSkeletonLoading, params, socialMediaType } = props;
    const { imageKey, likeKey, url, created_at, ...rest } = params

    // GET API
    const { data: PostsData, isPending, fetchStatus } = useQuery({ queryKey: [AdminUserSocialMediaPostsListAPI, rest, postId], queryFn: () => CustomFetch({ url: AdminUserSocialMediaPostsListAPI, params: { ...rest, post_id: postId } }, null, false), enabled: !!postId, refetchOnWindowFocus: false, select: (data) => data?.data?.data });

    useEffect(() => {
        if (!isPending) {
            stopSkeletonLoading();
        }
    }, [isPending]);
    if (fetchStatus == "fetching" || skeletonLoading) {
        return <SkeletonLoader width="206" height={206} rows={1} />
    }
    return (
        <>
            {(postId !== '' && PostsData?.length > 0) ?
                <div className='grid lg:grid-cols-5 md:grid-cols-3 grid-cols-2 gap-4' >
                    {PostsData?.map((post, index) => (
                        <div className='w-full overflow-hidden rounded-xl aspect-square bg-gray/20 relative cursor-pointer' key={index} onClick={() => window.open(post?.[url], "_blank")}>
                            <>
                                <ImageWithFallback src={post?.[imageKey]} alt="Post" width={1080} height={1080} className='w-full h-full object-cover' />
                                <div className='absolute left-0 right-0 w-full bottom-0 md:p-3 p-1.5'>
                                    <div className="flex flex-col gap-1 items-start">
                                        <div className="bg-black/50 z-10 inline-flex items-center px-2 py-0.5 rounded-lg gap-5">
                                            <span className='text-white font-semibold text-xs'>{moment.utc(post?.[created_at]).format("MMM DD, YYYY")}</span>
                                        </div>
                                        <div className="bg-black/50 z-10 inline-flex items-center px-2 py-1 rounded-lg gap-3.5">
                                            <div className='flex items-center gap-1.5 relative group'>
                                                {socialMediaType == "instagram" ? <InstagramLikesSVG /> : socialMediaType == "youtube" || socialMediaType == "tiktok" ? <RiEyeLine className="text-white min-w-5 w-5 h-5" /> : <FacebookLikeSVG />}
                                                <span className='text-white font-semibold text-xs'>{formatNumber(post?.[likeKey])}</span>
                                                <span className='text-white font-normal text-xs absolute group-hover:visible invisible bg-black z-10 inline-flex items-center px-2 py-0.5 rounded-lg left-1/2 -translate-x-1/2  -top-6'>{socialMediaType == "instagram" ? translations?.likes : socialMediaType == "youtube" || socialMediaType == "tiktok" ? "Views" :  translations?.likes}</span>
                                            </div>
                                            <div className='flex items-center gap-1.5 relative group'>
                                                <CommentsSVG />
                                                <span className='text-white font-semibold text-xs'>{formatNumber(post?.comment_count ?? post?.comments_count)}</span>
                                                <span className='text-white font-normal text-xs absolute group-hover:visible invisible bg-black z-10 inline-flex items-center px-2 py-0.5 rounded-lg left-1/2 -translate-x-1/2 -top-6'>{translations?.comments}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        </div>
                    ))}
                </div>
                :
                <span className="bg-gray/10 w-full h-full flex items-center justify-center p-5 rounded-xl text-xl font-semibold text-gray">{translations?.noPostFound}</span>
            }
        </>
    )
}

export default DetailInstagramPosts
